// The two ways to set athan or iqamah times: calculate them, or import a
// timetable. The one in use is marked.
import React from "react";
import { Link } from "react-router-dom";
import { TbClockShare } from "react-icons/tb";
import { FileUp } from "lucide-react";

const Card = ({ to, icon, title, text, inUse, tone }) => (
  <Link
    to={to}
    className={`group relative overflow-hidden rounded-2xl bg-white py-7 px-6 shadow-lg transition-all hover:shadow-xl ${inUse ? `ring-4 ${tone.ring}` : ""}`}
  >
    {inUse && (
      <span className={`absolute top-3 right-3 ${tone.badge} text-white text-xs font-bold px-3 py-1 rounded-full`}>In use</span>
    )}
    <div className="relative flex flex-col items-center gap-3 text-center">
      <div className={`inline-flex h-12 w-12 items-center justify-center rounded-full ${tone.icon}`}>{icon}</div>
      <h3 className="text-lg font-semibold text-slate-800">{title}</h3>
      <p className="text-sm text-gray-500">{text}</p>
    </div>
  </Link>
);

const MethodCards = ({ base, inUse, calculateTitle, calculateText, importText }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    <Card
      to={`${base}/calculation`}
      icon={<TbClockShare className="h-6 w-6" />}
      title={calculateTitle}
      text={calculateText}
      inUse={inUse === "method"}
      tone={{ ring: "ring-emerald-300", badge: "bg-emerald-500", icon: "bg-emerald-100 text-emerald-600" }}
    />
    <Card
      to={`${base}/import`}
      icon={<FileUp className="h-6 w-6" />}
      title="Import your timetable file"
      text={importText}
      inUse={inUse === "custom"}
      tone={{ ring: "ring-blue-300", badge: "bg-blue-500", icon: "bg-blue-100 text-blue-600" }}
    />
  </div>
);

export default MethodCards;
